module.exports = __webpack_public_path__ + "static/img/11.9f142f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/11.png
// module id = 3Fdp
// module chunks = 0